import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ToyotaImporterResidualsOptions, VehicleCondition } from 'src/app/settings-module/models/lease-residuals';
import { ToyotaImporterService } from 'src/app/settings-module/services/toyota-importer.service';

@Component({
  selector: 'app-residual-importer',
  templateUrl: './residual-importer.component.html',
  styleUrls: ['./residual-importer.component.scss']
})
export class ResidualImporterComponent implements OnInit {

  @Input() waitOnAction: boolean;

  vin = new UntypedFormControl('');
  includeNew = new UntypedFormControl(true);
  includeUsedCert = new UntypedFormControl(true);
  filterByVin = new UntypedFormControl(false);

  constructor(
    private toyotaImporterService: ToyotaImporterService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
  }

  triggerButtonDisabled = false;

  triggerResidualAutomation() {
    this.triggerButtonDisabled = true;
    setTimeout(() => this.triggerButtonDisabled = false, 15000);
    let vehicleConditions = []
    if (this.includeNew.value) {
      vehicleConditions.push(VehicleCondition.New)
    }
    if (this.includeUsedCert.value) {
      vehicleConditions.push(VehicleCondition.UsedCertified)
    }

    let options: ToyotaImporterResidualsOptions = {
      vehicleConditions
    }

    if (this.filterByVin.value) {
      options["vins"] = [this.vin.value]
    }
    
    this.toyotaImporterService.triggerToyotaResidualsImport(options).subscribe(() => {
      this.toastrService.info("Triggered toyota residuals importer")
      this.triggerButtonDisabled = false;
    })
  }
}
